const onSearchChange = (set) => (value) => {
  set({
    searchField: value,
    page: 1,
  });
};

export default onSearchChange;
